<aside *ngIf="!isHidden()" class="sidebar" [class.sidebar--expanded]="isExpanded()">
    <div class="sidebar__scroll-container">
      <nav class="sidebar__nav">
        <app-sidebar-item icon="calendar-clock-outline" label="mealPlanner" link="/meal-planner" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item icon="book-open-page-variant-outline" label="recipes" link="/recipes" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item icon="fridge-outline" label="household" link="/household" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item icon="cart-outline" label="shoppingList" link="/shopping-list" [isExpanded]="isExpanded()"></app-sidebar-item>
        <!-- Marketplace hidden until feature is deliverable
        <app-sidebar-item icon="storefront-outline" label="marketplace" link="/marketplace" [isExpanded]="isExpanded()"></app-sidebar-item>
        -->
        <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="format-list-bulleted-square" label="ingredients" link="/ingredients" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item *ngIf="isAdminOrModerator$ | async"
          icon="swap-horizontal"
          label="ingredientAssoc"
          link="/ingredient-associations"
          [isExpanded]="isExpanded()">
        </app-sidebar-item>
        <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="food-off-outline" label="leftovers" link="/leftovers" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item *ngIf="isAdmin$ | async" icon="progress-clock" label="pending" link="/pending" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="comment-outline" label="feedbacks" link="/feedbacks" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item *ngIf="isAdminOrModerator$ | async" icon="image-check-outline" label="recipePhotoModeration" link="/recipe-photo-moderation" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item *ngIf="isAdmin$ | async" icon="bullhorn-outline" label="announcements" link="/announcements" [isExpanded]="isExpanded()"></app-sidebar-item>
        <app-sidebar-item *ngIf="isAdmin$ | async" icon="shield-account-outline" label="admin" link="/admin" [isExpanded]="isExpanded()"></app-sidebar-item>
      </nav>

      <div class="sidebar__footer">
        <app-sidebar-item
          class="sidebar__footer-button"
          icon="message-alert-outline"
          label="leaveFeedback"
          [isExpanded]="isExpanded()"
          [disableHover]="true"
          (click)="openFeedbackDialog()"
        ></app-sidebar-item>
      </div>
    </div>
  
    <div
      class="sidebar__hover-zone"
      (mouseenter)="hovered = true"
      (mouseleave)="hovered = false"
    >
      <app-sidebar-toggle
        [hidden]="!hovered"
        [isExpanded]="isExpanded()"
        (toggle)="toggleSidebar()"
      ></app-sidebar-toggle>
    </div>
  </aside>
  
